import { vampProxyRiskLevels } from "@redotech/redo-dispute-common/vamp-proxy";
import * as z from "zod";

/**
 * Fixed trailing-30d dispute ratio (chargebacks ÷ orders, VAMP-style) — not
 * scoped by the dashboard date picker, so it stays comparable to network rules.
 */
export const getDisputeRatio = {
  name: "getDisputeRatio" as const,
  input: z.object({}),
  output: z.object({
    chargebackCountTrailing30d: z.coerce.number(),
    orderCountTrailing30d: z.coerce.number(),
    ratioTrailing30d: z.number().nullable(),
    thresholdRatio: z.number(),
    riskLevel: z.enum(vampProxyRiskLevels),
    orderVolumeRecordedAt: z.coerce.date().nullable(),
    errors: z.array(z.string()).nullish(),
  }),
};
